import i18n from 'i18next';

const render = function(mapEvent) {
    let translates = {
        metric: {
            'km': `${i18n.t('km')}`,
            'm': `${i18n.t('m')}`
        }
    };

    const { frameState } = mapEvent;
    this.viewState_ = !frameState ? null : frameState.viewState;

    this.updateElement_();
    // подмена переводов
    const _units: string = this.get('units');
    for (let _sourceUnits in translates[_units]) {
        if (translates[_units][_sourceUnits] !== undefined) {
            this.renderedHTML_ = this.renderedHTML_.replace(_sourceUnits, translates[_units][_sourceUnits]);
            this.innerElement_.innerHTML = `<span>${this.renderedHTML_}</span>`;
            this.renderedHTML = this.innerElement_.innerHTML;
        }
    }
};

export default new omjs.ol.control.ScaleLine({
    units: 'metric',
    render: render
});
